let globalState = {
    from: null,
    to: null,
};

const loadSearch = (elementId, redirect = true, searchPath = "/suggest", selectCallback = null) => {
    if (!window.location.origin) {
        window.location.origin = window.location.protocol +
            "//" +
            window.location.hostname +
            (window.location.port ? ":" + window.location.port : "");
    }

    const searchingMessages = {
        "en": "Searching...",
        "es": "Buscando...",
        "pt": "Procurando...",
        "fr": "Recherche...",
        "it": "Ricerca...",
        "de": "Suche...",
        "pl": "Badawczy...",
        "uk": "Пошук...",
        "ru": "Поиск...",
        "zh": "搜索...",
        "ja": "探す...",
        "nl": "Zoeken...",
        "da": "Søg...",
    };

    const searchHints = {
        "en": "Search for",
        "es": "Buscar",
        "pt": "Busca por",
        "fr": "Rechercher",
        "it": "Cerca",
        "de": "Suche nach",
        "pl": "Wyszukaj",
        "uk": "Шукати",
        "ru": "Искать",
        "zh": "搜索",
        "ja": "で検索",
        "nl": "Zoeken naar",
        "da": "Søg efter",
    };

    let state = {
        searchQuery: null,
        currentButton: null,
        searchTimeout: null,
    };

    const sortChoices = (first, second) => {
        const rawFirstPopulation = first.customProperties.population;
        const firstPopulation = rawFirstPopulation ? parseInt(rawFirstPopulation) : 0;
        const rawSecondPopulation = second.customProperties.population;
        const secondPopulation = rawSecondPopulation ? parseInt(rawSecondPopulation) : 0;
        return secondPopulation - firstPopulation;
    };

    const searchElement = document.getElementById(`selector-container__${elementId}`);
    const searchInput = document.getElementById(elementId);

    const selectorObject = new Choices(searchElement, {
        classNames: {
            containerInner: "choices-inner",
            list: "choices-list",
            item: "choices-item",
            itemChoice: "choices-item_choice",
            listDropdown: `choices-list_dropdown`,
            itemSelectable: "choices-item_selectable",
            input: "choices-input",
            noChoices: "no-choices"
        },
        shouldSort: true,
        sorter: sortChoices,
        callbackOnCreateTemplates: template => {
            return {
                choice: (classNames, data, message) => {
                    return template(`
          <div class="${classNames.item} ${classNames.itemChoice} ${data.disabled ? classNames.itemDisabled : classNames.itemSelectable}"
              data-select-text="${message}"
              data-choice ${data.disabled ? 'data-choice-disabled aria-disabled="true"' : 'data-choice-selectable'}
              data-id="${data.id}"
              data-value="${data.value}" ${data.groupId > 0 ? 'role="treeitem"' : 'role="option"'}
              data-path="${data.customProperties.path}">
            ${data.label}
          </div>
        `);
                },
            };
        },
    });

    const choicesListDropdown = searchInput.parentElement.querySelector(`div.choices-list_dropdown`);
    const choicesList = searchInput.parentElement.querySelectorAll("div.choices-list[role=\"listbox\"]")[0];

    const getSearchPath = () => {
        if (jinjaVars.lang === "en") return `${window.location.origin}/search?q=${state.searchQuery}`;
        else return `${window.location.origin}/${jinjaVars.lang}/search?q=${state.searchQuery}`;
    }

    const goToGCSE = () => {
        if (state.searchQuery && redirect) window.location.href = getSearchPath();
    }

    const showChoicesList = () => {
        choicesListDropdown.classList.add("is-active");
    }

    const hideChoicesList = () => {
        choicesListDropdown.classList.remove("is-active");
    }

    const doSearch = (query) => {
        hideChoicesList();

        const defaultMessage = searchingMessages["en"];
        const searchingMessageElement = document.getElementById(`searching-message__${elementId}`);
        const messageToUse = jinjaVars.lang in searchingMessages ? searchingMessages[jinjaVars.lang] : defaultMessage;

        searchingMessageElement.innerHTML = `${messageToUse}<span class="ellipsis"></span>`;
        searchingMessageElement.style.display = "flex";

        const onSuccess = responseObject => {
            const jsonData = JSON.parse(responseObject.responseText);
            const foundItems = jsonData.items;
            if (foundItems) {
                const choices = foundItems.map(item => {
                    return {
                        value: item.text,
                        selected: false,
                        disabled: false,
                        customProperties: {
                            path: item.id,
                            population: item.pop,
                        }
                    }
                });

                searchingMessageElement.style.display = "none";
                if (choices.length) {
                    selectorObject.setChoices(
                        choices,
                        "value",
                        "label",
                        true,
                    );
                } else {
                    let searchHint = `${searchHints["en"]}&nbsp;<b>&ldquo;${state.searchQuery}&rdquo;</b><i>&#9166;</i>`;
                    const lang = jinjaVars.lang;

                    if (lang in searchHints && lang !== "en") {
                        if (lang === "ja") searchHint = `<b>「${state.searchQuery}」</b>${searchHints[lang]}<i>&#9166;</i>`;
                        else searchHint = `${searchHints[lang]}&nbsp;<b>&ldquo;${state.searchQuery}&rdquo;</b><i>&#9166;</i>`;
                    }

                    selectorObject.setChoices(
                        [{
                            value: searchHint,
                            selected: false,
                            disabled: false,
                            customProperties: {
                                path: getSearchPath()
                            }
                        }],
                        "value",
                        "label",
                        true
                    );
                }

                showChoicesList();
            }
        }

        clearTimeout(state.searchTimeout);
        let pathToSearch = `${searchPath}?lang=${jinjaVars.lang}&term=${query}`;
        state = {
            ...state,
            searchTimeout: setTimeout(() => {
                httpGet(pathToSearch, onSuccess);
                searchingMessageElement.style.display = "none";
            }, 500)
        };
    }

    // Search results navigation with keyboard arrows
    const handleResultsNavigation = event => {
        const keyCode = event.code;
        const currentQuery = document.getElementById(elementId).value;
        const choicesListActive = choicesListDropdown.classList.contains("is-active");

        if (currentQuery && choicesListActive && choicesList && choicesList.hasChildNodes()) {
            const choicesChildren = choicesList.children;
            const selections = Array.from(choicesChildren)
                .filter(item => !item.classList.contains("no-choices"))
                .map(item => {
                    item.classList.remove("is-highlighted");
                    return item;
                });

            if (selections.length) {
                const selectNextButton = () => {
                    const nextSibling = state.currentButton ? state.currentButton.nextElementSibling : null;
                    const nextButton = nextSibling || selections[0];

                    nextButton.classList.add("is-highlighted")
                    nextButton.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'start'});

                    if (state.currentButton) state.currentButton.classList.remove("is-highlighted");
                    state = {
                        ...state,
                        currentButton: nextButton
                    };
                }

                const selectPreviousButton = () => {
                    const prevSibling = state.currentButton ? state.currentButton.previousElementSibling : null;
                    const prevButton = prevSibling || selections[selections.length - 1];

                    prevButton.classList.add("is-highlighted")
                    prevButton.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'start'});

                    if (state.currentButton) state.currentButton.classList.remove("is-highlighted");
                    state = {
                        ...state,
                        currentButton: prevButton
                    };
                }

                switch (keyCode) {
                    case "ArrowDown":
                        selectNextButton();
                        break;
                    case "ArrowUp":
                        selectPreviousButton();
                        break;
                }
            }
        }
    }

    const handleChoice = event => {
        if (redirect) {
            const pathToGo = event.detail.choice.customProperties.path;
            if (pathToGo) {
                window.location.href = pathToGo.startsWith("/") ?
                    `${window.location.protocol}//${window.location.host}${pathToGo}` :
                    pathToGo;
            }
        } else {
            const selectionData = event.detail.choice;
            searchInput.value = selectionData.value;
            searchInput.blur();
            if (selectCallback) selectCallback(selectionData);
            hideChoicesList();
        }
    }

    const addEvents = () => {
        const goToPath = path => {
            if (path) window.location.href = path.startsWith("/") ?
                `${window.location.protocol}//${window.location.host}${path}` :
                path;
        }

        searchInput.addEventListener("click", () => {
            if (choicesList.children.length && !choicesList.children[0].classList.contains("no-choices")) {
                showChoicesList();
            }
        });

        searchInput.addEventListener("keyup", e => {
            const currentQuery = e.target.value.replace(/([<>/])/g, "");

            if (currentQuery) {
                if (!state.searchQuery || state.searchQuery !== currentQuery) {
                    doSearch(currentQuery);
                    state = {...state, searchQuery: currentQuery};
                }
            } else {
                selectorObject.clearChoices();
                hideChoicesList();
            }
        });

        searchInput.addEventListener("keydown", e => {
            switch (e.code) {
                case "ArrowDown":
                case "ArrowUp":
                    e.preventDefault();
                    handleResultsNavigation(e);
                    break;
                case "Escape":
                    hideChoicesList();
                    searchInput.blur();
                    break;
                case "Enter":
                    e.preventDefault();
                    if (state.currentButton) {
                        goToPath();
                        const customData = {
                            detail: {
                                choice: {
                                    customProperties: {
                                        path: state.currentButton.getAttribute("data-path")
                                    },
                                    value: state.currentButton.innerText
                                }
                            }
                        }
                        handleChoice(customData);
                    } else setTimeout(() => goToGCSE(), 500);
                    break;
            }
        });

        document.addEventListener("click", e => {
            if (e.target && e.target.id !== elementId) hideChoicesList();
        });

        if (redirect) document.getElementById(`search-submit__${elementId}`).addEventListener("click", () => goToGCSE());

        selectorObject.passedElement.element.addEventListener(
            'choice', event => {
                handleChoice(event);
            }
        );

        selectorObject.passedElement.element.addEventListener("highlightChoice", e => {
            state = {
                ...state,
                currentButton: e.detail.el
            }
        });
    }

    addEvents();
};

loadSearch("global-search");
